import { TASKTRACK_SUCCESS, TASKTRACK_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const taskTrackReducer = (state = initialState, action) => {
    switch (action.type) {
        case TASKTRACK_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case TASKTRACK_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default taskTrackReducer;
